// extracted by mini-css-extract-plugin
module.exports = {"button":"GoButton_button__3gOHV"};